export default __webpack_public_path__ + "static/media/information--end-of-built-up-area--g2.c2932636.png";